import styled from '@emotion/styled';
import {
  Button,
  ListItem,
  SelectedSubject,
  SelectionList,
  Spacing,
  StyledTimetabelGradeSelectionScreen,
  TimetableHeading,
  Typography,
} from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { useEffect, useState } from 'react';

export interface EditTimetableDaysSelectionScreenProps {
  selectedGrade: string;
  heading: string;
  items: ListItem[];
  selectedSubject: SelectedSubject;
  onDaysListSelection: (id: ListItem[]) => void;
}
export const EditDaysSelectionScreen = ({
  selectedGrade,
  heading,
  items,
  selectedSubject,
  onDaysListSelection,
}: EditTimetableDaysSelectionScreenProps) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [listItems, setListItems] = useState<ListItem[]>(items);
  useEffect(() => {
    setListItems(items);
  }, [items]);
  const handleSelectionChange = (day: ListItem[]) => {
    setListItems(day);
    const isAnyItemSelected = day.some((item) => item.isChecked);
    setIsButtonDisabled(!isAnyItemSelected);
  };
  useEffect(() => {
    const isAnyItemSelected = items.some((item) => item.isChecked);
    setIsButtonDisabled(!isAnyItemSelected);
  }, [items]);
  const props: any = {};
  if (selectedSubject) {
    props.subject = {
      icon: selectedSubject.icon,
      text: selectedSubject.text,
    };
  }
  return (
    <>
      <StyledTimetabelGradeSelectionScreen>
        <Spacing marginBottom="xxl">
          <Typography
            data-cy="edit-day-text"
            variant={'textLabelMediumSurfaceVariant'}
          >
            EDIT CLASS
          </Typography>
        </Spacing>

        <TimetableHeading
          subject={selectedSubject}
          heading={heading}
          grade={selectedGrade}
        />
      </StyledTimetabelGradeSelectionScreen>
      <StyledDaysContainer
        marginBottom="xxxxxl"
        marginTop="xxxl"
        paddingLeft="xxxxl"
        paddingRight="xxxxl"
      >
        <SelectionList
          days={listItems}
          onSelection={(day: ListItem[]) => handleSelectionChange(day)}
        />
      </StyledDaysContainer>
      <ActionButtonContainer>
        <Button
          width="100%"
          onClick={() => onDaysListSelection(listItems)}
          disabled={isButtonDisabled}
          children="Save Changes"
          data-cy="edit-day-save-changes-btn"
        />
      </ActionButtonContainer>
    </>
  );
};

const StyledDaysContainer = styled(Spacing)`
  ${mq(BreakpointSizes.desktop)} {
    padding-left: calc(var(--rk-spacing-xxxxxxxl) * 2);
    padding-right: calc(var(--rk-spacing-xxxxxxxl) * 2);
  }
`;
const ActionButtonContainer = styled.div`
  ${mq(BreakpointSizes.desktop)} {
    padding-left: calc(var(--rk-spacing-xxxxxxxl) * 2);
    padding-right: calc(var(--rk-spacing-xxxxxxxl) * 2);
  }
  padding-right: var(--rk-spacing-xxxxl);
  padding-left: var(--rk-spacing-xxxxl);
  display: flex;
  gap: var(--rk-spacing-md);
  flex-direction: column;
`;
